
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaterGoogle as ObiWaterGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-water-google.js';
 
 
 

 
 export const ObiWaterGoogle = createComponent({
   react: React,
   tagName: 'obi-water-google',
   elementClass: ObiWaterGoogleElement,
   events: {
     
   }
  });
 
 